import PropTypes from 'prop-types';
import React from 'react';

export default function UndecoratedLayout({ children }) {
  return <>{children}</>;
}

UndecoratedLayout.propTypes = {
  children: PropTypes.node,
};
